import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@workspace/ui/components/card";
import type { SubscriptionInvoice } from "../subscription-invoices";
import { SubscriptionInvoicesList } from "./subscription-invoices-list";

type SubscriptionInvoicesSectionProps = {
  description?: string;
  invoices: SubscriptionInvoice[];
  orgSlug: string;
  title?: string;
};

export function SubscriptionInvoicesSection({
  description,
  invoices,
  orgSlug,
  title = "Facturas",
}: SubscriptionInvoicesSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description ? <CardDescription>{description}</CardDescription> : null}
      </CardHeader>
      <CardContent>
        <SubscriptionInvoicesList invoices={invoices} orgSlug={orgSlug} />
      </CardContent>
    </Card>
  );
}
